module.exports = __webpack_public_path__ + "img/add_desktop_1.a7530e97.png";